var map = {
	"./BTC_data.json": 2299,
	"./ETH_data.json": 3183,
	"./KAS_data.json": 1141,
	"./SHIB_data.json": 9320,
	"./SOL_data.json": 5864,
	"./latest_news_data.json": 6719
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 557;